function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Config from "./BaseConfig.js";
import { ALLOWED_URL_CONFIG } from "../internal/internalConstants.js";

var URLConfig = /*#__PURE__*/function (_Config) {
  _inherits(URLConfig, _Config);

  var _super = _createSuper(URLConfig);

  /**
   * @param {IURLConfig} userURLConfig
   */
  function URLConfig(userURLConfig) {
    var _this;

    _classCallCheck(this, URLConfig);

    _this = _super.call(this);

    var urlConfig = _this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);

    Object.assign(_assertThisInitialized(_this), {
      secure: true
    }, urlConfig);
    return _this;
  }

  _createClass(URLConfig, [{
    key: "extend",
    value: function extend(userURLConfig) {
      var urlConfig = this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);
      return new URLConfig(Object.assign({}, this, urlConfig));
    }
    /**
     * @param {string} value Sets the cname
     */

  }, {
    key: "setCname",
    value: function setCname(value) {
      this.cname = value;
      return this;
    }
    /**
     * @param {string} value Sets the secureDistribution
     */

  }, {
    key: "setSecureDistribution",
    value: function setSecureDistribution(value) {
      this.secureDistribution = value;
      return this;
    }
    /**
     * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
     */

  }, {
    key: "setPrivateCdn",
    value: function setPrivateCdn(value) {
      this.privateCdn = value;
      return this;
    }
    /**
     * @param value Sets whether or not to sign the URL
     */

  }, {
    key: "setSignUrl",
    value: function setSignUrl(value) {
      this.signUrl = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a long signature
     */

  }, {
    key: "setLongUrlSignature",
    value: function setLongUrlSignature(value) {
      this.longUrlSignature = value;
      return this;
    }
    /**
     * @param value Sets whether or not to shorten the URL
     */

  }, {
    key: "setShorten",
    value: function setShorten(value) {
      this.shorten = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a root path
     */

  }, {
    key: "setUseRootPath",
    value: function setUseRootPath(value) {
      this.useRootPath = value;
      return this;
    }
    /**
     * @param value Sets whether or not to deliver the asset through https
     */

  }, {
    key: "setSecure",
    value: function setSecure(value) {
      this.secure = value;
      return this;
    }
    /**
     * @param value Sets whether to force a version in the URL
     */

  }, {
    key: "setForceVersion",
    value: function setForceVersion(value) {
      this.forceVersion = value;
      return this;
    }
    /**
     * @param params Sets additional params
     */

  }, {
    key: "setQueryParams",
    value: function setQueryParams(params) {
      this.queryParams = params;
      return this;
    }
  }]);

  return URLConfig;
}(Config);

export default URLConfig;